//farmerImage
import vijaySingh from '../assets/farmerImage/vijay_singh.png';
import kishor from '../assets/farmerImage/kishor.png';

import corporate_slide_1 from '../assets/corporate/corporate_slide_1.png';
import corporate_slide_2 from '../assets/corporate/corporate_slide_2.png';

import Image from 'next/image';

export const CorporateArray = [
  {
    text: 'My general practice included 11-12 irrigations in the season. This year I have done only 4 irrigations and saved a lot on fertilizers. I have saved around 50-60% on spraying costs. All this with 100% increase in fruitfulness. Thanks to Fyllo.',
    image: corporate_slide_1,
  },
  {
    text: 'My general practice included 11-12 irrigations in the season. This year I have done only 4 irrigations and saved a lot on fertilizers. I have saved around 50-60% on spraying costs. All this with 100% increase in fruitfulness. Thanks to Fyllo.',
    image: corporate_slide_2,
  },
];

export default function CorporateSlide(text, image) {
  return (
    <div className=" grid place-items-center w-full">
      <Image
        className="full md:w-full h-full object-cover aspect-video rounded-md"
        src={image}
        alt={text}
        sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
      />
    </div>
  );
}

export const CorporateSlideArray = CorporateArray.map((corporate) => {
  return CorporateSlide(corporate.text, corporate.image);
});
